export default [
  {
    //  道成肉身的人子在家庭教会中显现作工
    path: "/Son-of-man-begins-speaking-in-house-churches",
    name: "Son-of-man-begins-speaking-in-house-churches",
    component: () =>
      import("@/views/Son-of-man-begins-speaking-in-house-churches/index.vue"),
    meta: {
      title: "道成肉身的人子在家庭教会中显现作工",
      order: 4,
      episode: "episode2",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/Son-of-man-begins-speaking-in-house-churches/bg-0.jpg",
          "images/Son-of-man-begins-speaking-in-house-churches/bg-0-front.png",
        ],
      },
    },
  },
];
